import { Separator } from "@app/components/core/Separator/Separator"
import { useGetStrings } from "@app/store/service/cmsService"
import { ORDER_LINE_TYPES, SCANCODE_TYPES } from "@app/utils/constants"
import { getPriceString } from "@app/utils/localeUtils"
import { useSelector } from "@tecreation/js-state-react"
import OrderLines from "../OrderLines/OrderLines"

const getActionDescription = action => {
	if (action.scanCodeTypeId === SCANCODE_TYPES.TICKET) {
		return (
			<span>
				Ticketcode: <span className="color-fg-secondary semibold">{action.scanCode}</span>
			</span>
		)
	}
	if (action.scanCodeTypeId === SCANCODE_TYPES.PRICEACTION) {
		return (
			<span>
				{action.priceAction} - {action.scanCode}
			</span>
		)
	}
	if (action.scanCodeTypeId === SCANCODE_TYPES.VOUCHER) {
		return (
			<span>
				{action.voucher}
				{action.scanCode ? " - " + action.scanCode : ""}
			</span>
		)
	}
}

const VoucherLine = ({ action }) => {
	const formattedOrder = useSelector(state => state.order.formattedOrder)
	let price = undefined

	if (formattedOrder && action.scanCodeTypeId === SCANCODE_TYPES.TICKET) {
		for (let line of formattedOrder.orderLines) {
			let fd = line.details[0]
			if (fd.scanCode && fd.scanCode === action.scanCode) {
				price = price === undefined ? 0 : price
				price += fd.amounts[0].grossAmount
			}
		}
	}

	if (formattedOrder && action.scanCodeTypeId === SCANCODE_TYPES.VOUCHER && action.details) {
		let vfd = action.details[0].voucherDetailToken
		price = 0
		for (let line of formattedOrder.orderLines) {
			let fd = line.details[0]
			if (fd.typeId === ORDER_LINE_TYPES.VoucherDetail && vfd === fd.voucherDetailToken) {
				price = fd.amounts[0].grossAmount / fd.quantity
				break
			}
			//Voucher like Entrace + Doppeliege can not be matched over the voucherDetailToken because it's used like a value voucher so we need to map over the scanCode
			if (fd.typeId === ORDER_LINE_TYPES.VoucherDetail && action.scanCode === fd.scanCode) {
				price += fd.amounts[0].grossAmount / fd.quantity
			}
		}
	}

	return (
		<div className="flex flex-justify-between mt-3 f5">
			<div>{getActionDescription(action)}</div>
			<div className="flex flex-items-center">{price && <div className="semibold">{getPriceString(price, undefined, false)}</div>}</div>
		</div>
	)
}

export default function UsedVouchers() {
	const priceActions = useSelector(state => state.order.priceActions)
	const { data: stringData } = useGetStrings()
	const { orderOverviewUsedVouchers } = stringData || {}

	if (!priceActions || priceActions.length === 0) {
		return null
	}
	return (
		<div className="mt-4">
			<div id="order-overview-vouchers-title" className="f4 semibold">
				{orderOverviewUsedVouchers}
			</div>
			<Separator />

			<div className="color-bg-secondary-100">
				<OrderLines ariaLabelledBy="order-overview-vouchers-title">
					{priceActions.map((e, i) => (
						<VoucherLine key={i} action={e} />
					))}
				</OrderLines>
			</div>
		</div>
	)
}
